<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">快速筛选</div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration" style="margin-right: 40px">
                  软件开通人姓名
                </div>
                <el-input
                  v-model="filters.handlerName"
                  placeholder="软件开通人姓名"
                  clearable
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">对应软件</div>
                <el-select
                  v-model="filters.softwareId"
                  placeholder="--未选择--"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in softwareOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.softwareName"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="filter-item buttons">
              <el-button
                type="primary"
                size="small"
                class="query-btn"
                @click="handleSearch"
                >查询</el-button
              >
              <el-button
                type="primary"
                size="small"
                plain
                @click="handleClearSearchForm"
                >重置</el-button
              >
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
          <div class="left">
            <el-button
              type="primary"
              size="small"
              class="add-btn"
              @click="openAddDialog"
              >+添加</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column label="软件开通人姓名" min-width="200">
          <template v-slot="{ row }">
            <template v-if="isRowEditing(row)">
              <work-order-user-select-v2
                v-if="allUserOptions.length"
                v-model="editDraft.handlerUsers"
                :allOptions="allUserOptions"
                :disabledOptions="getEditDisabledHandlerIds(row)"
                disabledOptionsRemark="软件开通人已存在"
                :multiple-limit="1"
                size="small"
              ></work-order-user-select-v2>
            </template>
            <span v-else>{{ row.handlerName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对应软件" min-width="280">
          <template v-slot="{ row }">
            <template v-if="isRowEditing(row)">
              <el-select
                v-model="editDraft.softwareIds"
                multiple
                collapse-tags
                filterable
                placeholder="请选择软件"
                style="width: 100%"
              >
                <el-option
                  v-for="item in softwareOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.softwareName"
                ></el-option>
              </el-select>
            </template>
            <span v-else>{{ formatSoftwareNames(row.softwareList) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template v-slot="{ row }">
            <template v-if="isRowEditing(row)">
              <el-button type="text" size="small" @click="handleSave(row)"
                >保存</el-button
              >
              <el-button type="text" size="small" @click="handleCancel"
                >取消</el-button
              >
              <el-button
                type="text"
                size="small"
                style="color: #f56c6c"
                @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
            <template v-else>
              <el-button type="text" size="small" @click="handleEdit(row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                style="color: #f56c6c"
                @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </template>
        </el-table-column>
      </template>
    </m-table-list>

    <el-dialog
      title="新增软件开通处理人"
      :visible.sync="addDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="resetAddForm"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        label-width="140px"
      >
        <el-form-item label="软件开通处理人" prop="handlerUsers">
          <work-order-user-select-v2
            v-if="allUserOptions.length"
            v-model="addForm.handlerUsers"
            :allOptions="allUserOptions"
            :disabledOptions="existingHandlerIds"
            disabledOptionsRemark="软件开通人已存在"
            :multiple-limit="1"
          ></work-order-user-select-v2>
        </el-form-item>
        <el-form-item label="对应软件" prop="softwareIds">
          <el-select
            v-model="addForm.softwareIds"
            multiple
            collapse-tags
            filterable
            placeholder="请选择软件"
            style="width: 100%"
          >
            <el-option
              v-for="item in softwareOptions"
              :key="item.id"
              :value="item.id"
              :label="item.softwareName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addSaving" @click="handleAddSave"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";
import { getAllUserOptions } from "@/components/workOrderUserSelectV2/userOptionsService.js";

export default {
  name: "privilege.softwar.list",
  components: {
    "m-table-list": tableList,
  },
  data() {
    const validateHandlerUsers = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error("请选择软件开通处理人"));
        return;
      }
      callback();
    };
    const validateSoftwareIds = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error("请选择对应软件"));
        return;
      }
      callback();
    };
    return {
      filters: {
        pageNo: 1,
        pageSize: 10,
        handlerName: "",
        softwareId: "",
      },
      softwareOptions: [],
      existingHandlerIds: [],
      allUserOptions: [],
      editingRowKey: null,
      editDraft: null,
      rowSnapshot: null,
      addDialogVisible: false,
      addSaving: false,
      addForm: {
        handlerUsers: [],
        softwareIds: [],
      },
      addFormRules: {
        handlerUsers: [{ validator: validateHandlerUsers, trigger: "change" }],
        softwareIds: [{ validator: validateSoftwareIds, trigger: "change" }],
      },
    };
  },
  created() {
    this.loadSoftwareOptions();
    this.loadExistingHandlers();
    this.loadUserOptions();
  },
  methods: {
    fetchListFunc: api.softwareHandler.pageByGroup,
    async loadSoftwareOptions() {
      const res = await api.softwareHandler.getSoftwareDropdown();
      this.softwareOptions = (res.data && res.data.data) || [];
    },
    async loadExistingHandlers() {
      const res = await api.softwareHandler.getHandlerList();
      const list = (res.data && res.data.data) || [];
      this.existingHandlerIds = list
        .map((item) => item.handlerUserId)
        .filter(Boolean);
    },
    async loadUserOptions() {
      this.allUserOptions = await getAllUserOptions();
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
    },
    formatSoftwareNames(softwareList) {
      if (!softwareList || !softwareList.length) return "-";
      return softwareList.map((item) => item.softwareName).join("、");
    },
    getSoftwareIds(softwareList) {
      if (!softwareList || !softwareList.length) return [];
      return softwareList.map((item) => item.id);
    },
    buildHandlerUsersFromRow(row) {
      if (!row.handlerUserId) return [];
      return [
        {
          userId: row.handlerUserId,
          userName: row.handlerName,
          beisenUserId: row.handlerBeisenId,
        },
      ];
    },
    buildHandlerPayload(users) {
      const user = users[0] || {};
      return {
        handlerUserId: user.userId,
        handlerBeisenId:
          user.beisenUserId != null ? String(user.beisenUserId) : "",
        handlerName: user.userName || "",
      };
    },
    getEditDisabledHandlerIds(row) {
      const currentId = row.handlerUserId;
      return this.existingHandlerIds.filter((id) => id !== currentId);
    },
    isRowEditing(row) {
      return this.editingRowKey === row.handlerUserId;
    },
    handleEdit(row) {
      if (this.editingRowKey && this.editingRowKey !== row.handlerUserId) {
        this.$message.warning("请先保存或取消当前编辑行");
        return;
      }
      this.rowSnapshot = JSON.parse(JSON.stringify(row));
      this.editingRowKey = row.handlerUserId;
      this.editDraft = {
        handlerUsers: this.buildHandlerUsersFromRow(row),
        softwareIds: this.getSoftwareIds(row.softwareList),
      };
    },
    handleCancel() {
      this.editingRowKey = null;
      this.editDraft = null;
      this.rowSnapshot = null;
    },
    async handleSave() {
      if (!this.editDraft.handlerUsers.length) {
        this.$message.warning("请选择软件开通人");
        return;
      }
      if (!this.editDraft.softwareIds.length) {
        this.$message.warning("请选择对应软件");
        return;
      }
      const payload = {
        softwareIds: this.editDraft.softwareIds,
        ...this.buildHandlerPayload(this.editDraft.handlerUsers),
      };
      await api.softwareHandler.bindBySoftwareIds(payload);
      this.$message.success("保存成功");
      this.handleCancel();
      await this.loadExistingHandlers();
      this.$refs.tableList.getMainData();
    },
    handleDelete(row) {
      const source =
        this.isRowEditing(row) && this.rowSnapshot ? this.rowSnapshot : row;
      if (!source.handlerUserId) {
        this.$message.warning("缺少开通人信息，无法删除");
        return;
      }
      this.$confirm("是否删除该软件开通人及其全部软件关联？", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await api.softwareHandler.clearAll({
          handlerUserId: source.handlerUserId,
        });
        this.$message.success("删除成功");
        if (this.isRowEditing(row)) {
          this.handleCancel();
        }
        await this.loadExistingHandlers();
        this.$refs.tableList.getMainData();
      });
    },
    openAddDialog() {
      if (this.editingRowKey) {
        this.$message.warning("请先保存或取消当前编辑行");
        return;
      }
      this.addDialogVisible = true;
    },
    resetAddForm() {
      this.addForm = {
        handlerUsers: [],
        softwareIds: [],
      };
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate();
        }
      });
    },
    handleAddSave() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        this.addSaving = true;
        try {
          const payload = {
            softwareIds: this.addForm.softwareIds,
            ...this.buildHandlerPayload(this.addForm.handlerUsers),
          };
          await api.softwareHandler.batchBind(payload);
          this.$message.success("保存成功");
          this.addDialogVisible = false;
          await this.loadExistingHandlers();
          this.$refs.tableList.getMainData();
        } finally {
          this.addSaving = false;
        }
      });
    },
  },
};
</script>
